import { useRef, useState, useEffect, React } from "react";
import { useBlogContext } from "../../fetchdata/BlogContext";
import Header from "../components/Header"; // Replace this with your Header component
import Footer from "../components/Footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import axiosInstance, { Homeurl,keyLogin } from "../../axiosInstance";


// import required modules
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import RangeSlider from "../components/extra/RangeSlider";
import { Helmet } from "react-helmet";
import CreateSlug from "../components/extra/CreateSlug";
import { encrypt } from "../../helper/encryption";
import setCookie from "../../helper/setCookie";
import getDecryptData from "../../helper/getDecryptData";

const Category = () => {
  const { Headers, isHeader } = useBlogContext();

  const navigate = useNavigate();

  const [enquireData, setEnquireData] = useState([]);

  const [layout, setLayout] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [isProducts, setIsProducts] = useState(true);

  const [RProducts, setRProducts] = useState([]);

  const [OTPVerify, setOTPVerify] = useState(false);
  const [GetOtpRes, setOtpRes] = useState(null);
  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
  const [ExistingUser, setExistingUser] = useState([]);

const swiperRef = useRef();

const swiperRefLocal = useRef();

const handleMouseEnter = () => {
  swiperRefLocal?.current?.swiper?.autoplay?.stop();
};

const handleMouseLeave = () => {
  swiperRefLocal?.current?.swiper?.autoplay?.start();
};

function formatDate(dateString) {
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  return new Date(dateString).toLocaleDateString('en-US', options);
}


        const verifyOTPFinal = async () => {
          setSubmitLoading(false); // Set loading to false after request completion
      
          const MYOTPinputs = { OTP: enquireData.otp, HASHOTP: GetOtpRes.otp }
      
          try {
            const response = await axiosInstance.post(`/login-verify-otp`, MYOTPinputs); // Await the axios post request
            console.log('responseresponse', response)
            const { success } = response.data
            if (success) {
      
              setOTPVerify(true);
      
            }
          } catch (error) {
            console.error('Error On OTP Verify:', error);
            toast.error(error.response.data.message);
            setOTPVerify(false);
  
          } finally {
            setSubmitLoading(true); // Set loading to false after request completion
          }
       
        }
        const ChangePhone = async () => {
          setOTPVerify(false);
          setOtpRes(null);
          setEnquireData((prevData) => ({
            ...prevData,
            otp: null,
          })); // Clear form fields

        }

    const submitOTP = async (phone) => {
      if (!phone) {
        toast.error('Please Enter a phone number.');
        return null;

      } else if (phone.length !== 10) {
        toast.error('Please Enter a 10-digit phone number.');
        return null;
      }  
      setSubmitLoading(false); // Set loading to true before making the request
      const inputs = {
        phone:phone
      }
      setOtpRes(null);
      try {
        const response = await axiosInstance.post(`/signup-login-new/`, inputs); // Await the axios post request
        console.log('responseresponse', response)
        setOtpRes(response.data); // Set the response data to state
        // console.log('dataotp', response.data.password);
        const { existingUser} = response.data;
        if(existingUser){
          setExistingUser(existingUser);
        }

      } catch (error) {
        console.error('Error On taxes:', error);
        toast.error(error.response.data.message);
      } finally {
        setSubmitLoading(true); // Set loading to false after request completion
      }
    };

    const placeholder = `data:image/svg+xml,%3Csvg width='800px' height='800px' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='120' height='120' fill='%23EFF1F3'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M33.2503 38.4816C33.2603 37.0472 34.4199 35.8864 35.8543 35.875H83.1463C84.5848 35.875 85.7503 37.0431 85.7503 38.4816V80.5184C85.7403 81.9528 84.5807 83.1136 83.1463 83.125H35.8543C34.4158 83.1236 33.2503 81.957 33.2503 80.5184V38.4816ZM80.5006 41.1251H38.5006V77.8751L62.8921 53.4783C63.9172 52.4536 65.5788 52.4536 66.6039 53.4783L80.5006 67.4013V41.1251ZM43.75 51.6249C43.75 54.5244 46.1005 56.8749 49 56.8749C51.8995 56.8749 54.25 54.5244 54.25 51.6249C54.25 48.7254 51.8995 46.3749 49 46.3749C46.1005 46.3749 43.75 48.7254 43.75 51.6249Z'
     fill='%23687787'/%3E%3C/svg%3E`;
  
  const getProducts = async () => {
        const decryptdatajson = await getDecryptData();
        if (decryptdatajson && decryptdatajson?._id) {
 
          setEnquireData((prevData) => ({
            ...prevData,
            fullname: decryptdatajson.username,
            email: decryptdatajson.email,
            phone: decryptdatajson.phone,

          })); // Clear form fields
          setOtpRes(true);
          setEnquireData((prevData) => ({
            ...prevData,
            otp: null,
          })); // Clear form fields

          setOTPVerify(true);

        }

    try {
      const { data } = await axiosInstance.get("/all-home-products");
      setRProducts(data.products);
      setIsProducts(false); // Set loading state to false in case of an error
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsProducts(false); // Set loading state to false in case of an error
    }
  };

  const getData = async () => {
    try {
      const { data } = await axiosInstance.get(`/home-layout-data`);
      setLayout(data.homeLayout);
      setIsLoading(false); // Set loading state to false in case of an error
    } catch (error) {
      console.log(error);
      toast.error("Error fetching Home layout!");
      setIsLoading(false); // Set loading state to false in case of an error
    }
  };

  useEffect(() => {
    getData();
    getProducts();
  }, []);

  const startMin = 0;
  const startMax = 100;
  const min = 0;
  const max = 200;
  const step = 1;

  const [selectedRanges, setSelectedRanges] = useState([]);

  const [selectedFilters, setSelectedFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [Cat, setCat] = useState([]);
  const [CatT, setTCat] = useState([]);
  const [CatImage, setTCatImage] = useState("");

  const [CatM, setMCat] = useState([]);

  const [Pro, setPro] = useState([]);
  const [Attr, setAttr] = useState([]);
  const [fillter, setfillter] = useState("");

  const [Viewfillter, setViewfillter] = useState([]);

  const [isCat, setIsCat] = useState(true);
  const [count, setcount] = useState("100");
  const [Sidebar, setIsSidebar] = useState(false);

  const handlecountChange = (event) => {
    setcount(event.target.value);
  };

  const { id ,location} = useParams();
  const capLocation = location?.charAt(0).toUpperCase() + location?.slice(1);
   const capitalizedLocation = capLocation.replaceAll('-', ' ');
 
  const [products, setProducts] = useState([]);
  const [ratings, setRatings] = useState([]);

  const getRating = async () => {
    try {
      const { data } = await axiosInstance.get(`/all-rating`);
      setRatings(data.ratings);
      // console.log('getRating', data)
    } catch (error) {
      console.error("Error fetching rating:", error);
    }
  };

  const [Specifications, setspecifications] = useState([]);

  const getCategory = async (fillter, page, price) => {
    setIsSidebar(false);
    if (window.__PRELOADED_DATA__?.MainCat?.slug !== id || window.__PRELOADED_DATA__ === undefined) {
      try {
        window.scrollTo(0, 0);
        setIsCat(true);
        const encodedFilter = encodeURIComponent(fillter); // Encode the filter string
         const { data } = await axiosInstance.get(
          `/all/category-slug/${id}?filter=${encodedFilter}&price=${price}&page=${page}&perPage=${count}&location=${location}`
        );
        setCat([]);
        setTCat([]);
        setMCat([]);
        if (data?.success) {
          setCat(data?.categories);
          setTCat(data.MainCat);
          console.log("data.MainCat", data.MainCat);
          setEnquireData((prevData) => ({
            ...prevData,
            service: data.MainCat?.title,
            category: data.MainCat?.title,
          })); // Clear form fields

          setspecifications(data.MainCat.specifications.specifications || []);

          setTCatImage(data.MainCat.image);
          setTotalPages(data?.proLength);
          setfillter(fillter);

          setProducts(data?.productsFilter);
         console.log('setProducts',data?.productsFilter)
          setPro(data?.products);
          setMCat(data?.MainCat);
        }

        // console.log('datadatadata', data)
      } catch (error) {
        console.log(error);
        toast.error("Error fetching Category!");
        navigate("/404");
      } finally {
        setIsCat(false);
      }
    } else {

      setCat([]);
      setTCat([]);
      setMCat([]);

      setCat(window.__PRELOADED_DATA__?.categories);
      setTCat(window.__PRELOADED_DATA__.MainCat);
      console.log("data.MainCat", window.__PRELOADED_DATA__.MainCat);
      setEnquireData((prevData) => ({
        ...prevData,
        service: window.__PRELOADED_DATA__.MainCat?.title,
      })); // Clear form fields
      setspecifications(window.__PRELOADED_DATA__.MainCat.specifications.specifications || []);

      setTCatImage(window.__PRELOADED_DATA__.MainCat.image);
      setTotalPages(window.__PRELOADED_DATA__?.proLength);
      setfillter(fillter);

      setProducts(window.__PRELOADED_DATA__?.productsFilter);

      setPro(window.__PRELOADED_DATA__?.products);
      setMCat(window.__PRELOADED_DATA__?.MainCat);

      setIsCat(false);

    };
  };

  const Opensidebar = async () => {
    setIsSidebar(true);
  };
  const Closesidebar = async () => {
    setIsSidebar(false);
  };

  const getAttribute = async () => {
    try {
      const { data } = await axiosInstance.get("/all-attribute");
      // console.log("attr", data);
      setAttr(data.Attribute);
    } catch (error) {
      console.error("Error fetching attributes:", error);
    }
  };

    // Function to handle checkbox selection
    const handleCheckboxChange = (event) => {
      const { value, checked } = event.target;
      // console.log('valuevaluevalue', value)
      setSelectedFilters((prevState) => {
        // If checked, add the value to selectedFilters, otherwise remove it
        if (checked) {
          return { ...prevState, [value]: checked };
        } else {
          const { [value]: removedValue, ...rest } = prevState;
          return rest;
        }
      });
  
      // console.log('selectedFilters', selectedFilters)
      setCurrentPage(1);
    };

  // Function to handle checkbox selection
  const handleCheckboxChangeOld = (event) => {
    const { value, checked } = event.target;
    const [attrName, attrValue] = value.split(",");
  
    setSelectedFilters((prevFilters) => {
      const existing = prevFilters[attrName]?.split(",") || [];
  
      const updated = checked
        ? [...new Set([...existing, attrValue])] // Add unique
        : existing.filter((v) => v !== attrValue); // Remove unchecked
  
      if (updated.length === 0) {
        const { [attrName]: removed, ...rest } = prevFilters;
        return rest;
      }
  
      return {
        ...prevFilters,
        [attrName]: updated.join(","),
      };
    });
  
    setCurrentPage(1);
  };
  

  const removeFilter = ({ key, val }) => {
    const value = `${key},${val}`;
    setSelectedFilters((prevState) => {
      const { [value]: removedValue, ...rest } = prevState;
      return rest;
    });

    setCurrentPage(1); // Set current page to 1
  };

  const generateQueryString = () => {
    const filterObj = {};

    // Construct filter object from selected filters
    Object.entries(selectedFilters).forEach(([key, value]) => {
      const [attrKey, attrValue] = key.split(",");

      // Check if attribute key already exists in filter object
      if (filterObj[attrKey]) {
        // Append to existing attribute value if key exists
        filterObj[attrKey] += `,${attrValue}`;
      } else {
        // Create new attribute if key doesn't exist
        filterObj[attrKey] = attrValue;
      }
    });

    // Convert filter object to JSON string
    const filterString = JSON.stringify(filterObj);

    // console.log(filterString); // Output the generated filter string
    setViewfillter(filterString);
    setTimeout(function () {
      getCategory(filterString, currentPage, selectedRanges);
    }, 100);
  };

  // const handleCategoryLinkClick = (categoryId) => {
  //   getCategory(fillter, currentPage, selectedRanges);
  // };

  useEffect(() => {
    generateQueryString(); // Call generateQueryString when selectedFilters change
    getRating();
    setIsCat(true); // Set loading state to true
    getAttribute();
    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
         
           setEnquireData((prevData) => ({
            ...prevData,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          })); // Clear form fields

          console.log("Latitude:", position.coords.latitude);
          console.log("Longitude:", position.coords.longitude);
        },
        
      );
    } else {
      toast.error('Geolocation is not supported by this browser.');
      return null;
     }


    // getCategory(fillter,currentPage,selectedRanges);
  }, [id, currentPage, selectedFilters, selectedRanges, count,location]); // Empty dependency array ensures that the effect runs once after the initial render

  useEffect(() => {
    setSelectedRanges([]);
  }, [id]); // Empty dependency array ensures that the effect runs once after the initial render

  // useEffect(() => {
  //   generateQueryString(); // Call generateQueryString when selectedFilters change
  // }, [selectedFilters,selectedRanges]); // Add selectedFilters as a dependency

  // Function to filter products based on selected attributes

  const [priceRange, setPriceRange] = useState({ min: 0, max: 100 });

  function handleChange(e) {
    setPriceRange({
      priceRange,
      [e.target.name]: parseInt(e.target.value),
    });
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Calculate the maximum sale price to determine the range
  const maxSalePrice = Math.max(
    ...products.map((product) => product.salePrice)
  );

  // Determine the number of ranges based on the maximum sale price
  const numRanges = Math.ceil(maxSalePrice / 10000);

  // Generate price ranges dynamically
  const priceRanges = Array.from({ length: numRanges }, (_, index) => ({
    min: index * 10000,
    max: (index + 1) * 10000,
  }));

  // Filter out the price ranges that match the actual sale prices of your products
  const filteredPriceRanges = priceRanges.filter((range) =>
    products.some(
      (product) =>
        product.salePrice >= range.min && product.salePrice < range.max
    )
  );

  const handleCheckpriceboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedRanges([...selectedRanges, value]);
    } else {
      setSelectedRanges(selectedRanges.filter((range) => range !== value));
    }
    setCurrentPage(1);
    // console.log(selectedRanges)
  };

  const addedVariations = new Set();


   const [loading, setLoading] = useState(true); // Add loading state
 
  const [EnquireShow, setEnquireShow] = useState(false);

  const [EnquireStatus, setEnquireStatus] = useState(false);

  const [StepForm, setStepForm] = useState(0);
  

   const [data, setData] = useState([]);
    const [filteredCities, setFilteredCities] = useState([]);
  
  
   
     const fetchData = async () => {
      setLoading(true);
      console.log("response.data start");
  
      try {
        const response = await axiosInstance.get("/get-all-zones");
        console.log("response.data.Zones,", response.data.Zones);
        setData(response.data.Zones);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchData();
    }, []); // Empty dependency array ensures that the effect runs once after the initial render
  

  const handleNext = () => {
    setStepForm((prevStep) => prevStep + 1);
  };

  const handlePrevious = () => {
    setStepForm((prevStep) => prevStep - 1);
  };



  const enquireToggle = () => {
    if (EnquireShow) {
      setEnquireShow(false);
    } else {
      setEnquireShow(true);
    }
  };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    str = str.replace(/\d+/g, "");
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const validate = (email) => {
    // Regular expression to check for invalid characters
    const invalidCharsRegex = /[^\w@_.]| /; // Disallow spaces and any character that's not a word character, @, or .

    // Check for invalid cases
    if (email === "-" || email === "+") {
      return "";
    } else if (invalidCharsRegex.test(email)) {
      return ""; // Return empty string if invalid characters (including spaces) are found
    } else {
      return email; // Return the original email if valid
    }
  };

  const handleEnquireChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Determine the new value based on input type
    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    // Capitalize each word for specific fields
    if (name === "fullname") {
      newValue = capitalizeEachWord(newValue);
    }

    if (name === "email") {
      newValue = validate(newValue);
    }

    if (name === "phone") {
      // Replace non-digit characters
      newValue = value.replace(/\D/g, ""); // This allows only digits

      // if (newValue.startsWith('0')) {
      //   newValue = newValue.slice(1); // Remove the first '0'
      // } 

      // Limit to 10 digits
      if (newValue.length > 13) {
        newValue = newValue.slice(0, 13); // Limit to 10 digits
      }
    }

  // Capitalize text for the 'username' field
  if (name === "state") {
    const selectedState = data.find((state) => state._id === newValue);
    if (selectedState) {
      setFilteredCities(selectedState.cities);
      setEnquireData((prevData) => ({
        ...prevData,
        statename: selectedState.name,
        city: "",
      }));
    }
    console.log("selectedState", selectedState, newValue, data);
  }


    // Update form data with the new value
    setEnquireData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const handleSendEnquire = async () => {
    const fields = [
      { name: "fullname", message: "Please enter Full Name" },
      { name: "phone", message: "Please enter phone number" },
      { name: "email", message: "Please enter email" },
      { name: "requirement", message: "Please enter requirement" },
    ];

    for (const field of fields) {
      if (!enquireData[field.name]) {
        toast.error(field.message);
        setEnquireStatus(false);
        return;
      }
    }
   


    try {
      setEnquireStatus(true);
    const  data = await toast.promise(axiosInstance.post(`/send-enquire-category`, enquireData), {
        loading: "Enquire Submiting...", // Loading message
        success: "Enquire Submited Successfully!", // Success message
        error: "Failed to Submit Enquire.", // Error message
      });

            const { success, user } = data.data;
              if (success) {
                if(user){
                  const { _id, username, email, type, phone } = user;
                  const userToStore = { _id, username, email, type, phone };
        
                  // Encrypt the user data and set a cookie
                  const encryptedData = encrypt(JSON.stringify(userToStore), keyLogin);
                  setCookie('token', encryptedData, 7); // Expires in 7 days
        
                }
             
                enquireToggle();
                setEnquireData((prevData) => ({
                  ...prevData,
                 
                  requirement: "",
                })); // Clear form fields

              } 

    
    } catch (error) {
      console.error("Failed to send email:", error);
    toast.error(error?.response?.data?.message);
    } finally {
      setEnquireStatus(false);
    }
  };

    useEffect(() => {
      if(OTPVerify && ExistingUser && ExistingUser._id){
        const { _id, username, email, type, phone } = ExistingUser;
          const userToStore = { _id, username, email, type, phone };
  
        // Encrypt the user data and set a cookie
        const encryptedData = encrypt(JSON.stringify(userToStore), keyLogin);
        setCookie('token', encryptedData, 7); // Expires in 7 days
  
        setTimeout(() => {
        
          window.location.reload(); // Corrected method to reload the page
        
        }, 500);
  
      }
    }, [OTPVerify]);

      const handleScroll = (e) => {
    e.preventDefault();
    const target = document.querySelector('#allservice');
    window.scrollTo({
      top: target.offsetTop, 
      behavior: 'smooth',
    });
  };


  return (
    <>
      <Header />


      <section className="py-5 border-bottom">
  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-6 col-12 pe-lg-5">
         {isCat ? 
         <>
                <div className="skeleton w-75 mb-4" style={{ height: "45px" }}  />
                <div className="skeleton w-25 mb-4" style={{ height: "25px" }}  />
                <div className="skeleton w-100 mb-3" style={{ height: "45px" }}  />

            <div className="row mt-5 service-single-nav">
  {[...Array(4)].map((_, index) => (
    <div key={index} className="col-2 col-md-3 mb-2">
      <div className="link-dark">
        <div
          style={{ aspectRatio: "1/1", objectFit: "cover" }}
          alt="Best Value"
          className="skeleton img-fluid rounded-pill w-75 mx-auto"
        />
        <div
          className="skeleton w-100 mt-2"
          style={{ height: "25px" }}
        />
      </div>
    </div>
  ))}
</div>


         </>
         : 
         <>
    <h1 className="fw-bold">  {CatT.slide_head?.replace(/\$\{location\}/g, capitalizedLocation)} </h1> 
 {/* <p className="text-muted">
          <i className="bi bi-star-fill me-1 text-warning" />
          4.81 (189K bookings)
        </p> */}
{/* 
    <a href="#" className="link-dark" onClick={handleScroll}>
          <div className="bg-light rounded-3 d-flex gap-3 p-3">
            <i className="bi bi-heart-fill text-primary" />
            <p className="small m-0"> Book Now</p>
            <i className="bi bi-chevron-right ms-auto" />
          </div>
        </a> */}

              <div className="row mt-5 service-single-nav">

         {Cat.length > 0 &&
                  Cat.map((Cat) => ( 
                        <div className="col-2 col-md-3 mb-2">
            <Link to={`/${CreateSlug(location)}/${Cat.slug}`} className="link-dark">
              <div className="text-center">
                <img
                src={Cat.image}
                  style={{ aspectRatio: "1/1", objectFit: "cover" }}
                  alt="Best Value"
                  className="img-fluid rounded-pill w-75"
                />
                <p className="small pt-2 m-0">  {Cat.title}</p>
              </div>
            </Link>
          </div>  ))
                }
      
        
        </div>

         </>
        }
        
       
    
  
      </div>
      <div className="col-lg-6 col-12">
              {isCat ? 
       
                <div className="skeleton w-100 mb-4" style={{ aspectRatio:'4/3' }}  />
                :   
                  <img
          src={CatImage}
          className="w-100 rounded border"  style={{ aspectRatio:'4/3',objectFit:'cover' }}
        /> }
      </div>
    </div>
  </div>
</section>


<section>
  <div className="container">
    <div className="row g-0">
      <div className="col-lg-8 border-end">
        <div
          className="pe-lg-5 py-5"
          data-bs-spy="scroll"
          data-bs-target="#navbar-example2"
          data-bs-root-margin="0px 0px -40%"
          data-bs-smooth-scroll="true"
          tabIndex={0}
        >
          {/* Bestseller */}
          <div id="bestseller">
            <div className="col">
                            <div className="d-flex justify-content-between gap-4 g-2" id="allservice">
                             <h3 className="fw-bold mb-4">All Service</h3>
                              <div className="col-auto">
                                <select
                                  className="form-select w-auto"
                                  id="sorting"
                                  value={count}
                                  onChange={handlecountChange}
                                  style={{minWidth:100}}
                                >
                                  <option value="50">50</option>
                                  <option value="100">100</option>

                                  <option value="200">200</option>

                                  <option value="500">500</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          
           
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2">
              {/* 1. Regular Washroom Cleaning */}

               {isCat
                      ? Array.from({ length: 4 }).map((_, index) => (
                        <div
                          key={index}
                      className="mb-4">
  <div className="rounded-4 border bg-white overflow-hidden position-relative">
      <div
       className="skeleton img-fluid w-100 h-auto rounded-0" 
      style={{ aspectRatio: "394 / 221", objectFit: "cover" }}
    />
    <div className="p-4">
      <div
                            className=" skeleton w-75 mb-2"
                            style={{ height: 25, borderRadius: 5 }}
                          />
                            <div
                            className=" skeleton w-25  mb-2"
                            style={{ height: 20, borderRadius: 5 }}
                          />
                            <div
                            className=" skeleton w-25  mb-3"
                            style={{ height: 20, borderRadius: 5 }}
                          />
                      <div class="border-bottom mb-3"/>

                       <div  className=" skeleton w-75 mb-2"
                            style={{ height: 15, borderRadius: 5 }}
                          />
                          <div  className=" skeleton w-75 mb-3"
                            style={{ height: 15, borderRadius: 5 }}
                          />
                            <div
                            className=" skeleton w-25 "
                            style={{ height: 25, borderRadius: 5 }}
                          />
      </div>
                          
                        </div>
                            </div>
                      ))
                      : Pro.map((product) => {
   const Images = product.images || [];

                        return ( 
              <div className="mb-4">
                <div className="rounded-4 border bg-white overflow-hidden position-relative">
                  {/* <span className="badge text-bg-success rounded-2 px-2 py-1 position-absolute m-3 top-0 end-0">
                    HH EXCLUSIVE
                  </span> */}
                  <img
                    src={product.pImage}
                    className="img-fluid w-100 h-auto"
                    alt="Regular Washroom Cleaning"
                    loading="lazy" 
                    style={{aspectRatio:'394/221',objectFit:'cover'}}
                    
                  />
                  <div className="service-grid-item p-4">
                    <div className="border-bottom pb-3">
                      <h5 className="fw-bold">   {product.title}  </h5>
                      <p className="text-muted mb-1 small">
                        <i className="bi bi-star-fill text-warning me-1" />
                        4.9 (12.4K)
                      </p>
                      <p className="m-0">
                        <span className="fw-bold">₹{product.salePrice}</span> · 30 mins
                      </p>
                    </div>
                    <ul className="text-muted px-3 pt-3">
                      {product?.features.length !== 0 && product?.features.map((feature, index) => (<li key={index} >{feature}</li>))}
 
                    </ul>
                
                 <Link to={`/product/${product.slug}`} 
                      
                      className="fs-6 stretched-link"
                     
                    >
                      View details
             </Link>
                  </div>
                </div>
              </div>
                     ) })
                    }
               
            

                    {Pro.length === 0 && !isCat && ( 
                      <img src="/assets/img/no-product-found.png" className="w-100"/>
                    
                    )}


            </div>

            
 <div className="d-flex justify-content-between mt-6">
                      <ul className="pagination">
                        <li
                          className={`page-item ${currentPage === 1 ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            type="button"
                            onClick={() => handlePageChange(currentPage - 1)}
                          >
                            <i className="ri-arrow-left-s-line me-1"></i>Prev
                          </button>
                        </li>
                      </ul>
                    
                      <ul className="pagination">
                        <li
                          className={`page-item ${totalPages === 0 ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            type="button"
                            onClick={() => handlePageChange(currentPage + 1)}
                            aria-label="Next"
                          >
                            Next<i className="ms-1 ri-arrow-right-s-line"></i>
                          </button>
                        </li>
                      </ul>
                    </div>


          </div>
          {/* Winter special */}
        </div>
      </div>
      <div className="col-lg-4">
        {/* <div className="sticky-sidebar ps-lg-5 py-lg-5 mb-5 mb-lg-0">
          <a href="#" className="link-dark">
            <div className="bg-light rounded-3 d-flex gap-2 px-3 py-2 mb-3">
              <i className="bi bi-percent text-primary" />
              <div>
                <p className="fw-bold mb-0">Save 15% on every order</p>
                <p className="small text-muted m-0">Get Plus now</p>
              </div>
            </div>
          </a>
          <a href="#" className="link-dark">
            <div className="bg-light rounded-3 d-flex gap-2 px-3 py-2 mb-3">
              <i className="bi bi-tag-fill text-success" />
              <div>
                <p className="fw-bold mb-0">Assured cashback on Paytm</p>
                <p className="small text-muted m-0">Up to $500 off</p>
              </div>
            </div>
          </a>
          <a href="#" className="link-dark">
            <div className="bg-light rounded-3 d-flex gap-2 px-3 py-2 mb-3">
              <i className="bi bi-tag-fill text-success" />
              <div>
                <p className="fw-bold mb-0">5% Simpl cashback ip to $750</p>
                <p className="small text-muted m-0">
                  Get up to Rs.750 cashback
                </p>
              </div>
            </div>
          </a>
          <a href="#" className="link-dark">
            <div className="bg-light rounded-3 d-flex gap-2 px-3 py-2 mb-3">
              <i className="bi bi-tag-fill text-success" />
              <div>
                <p className="fw-bold mb-0">CRED Pay</p>
                <p className="small text-muted m-0">Cashback up to $500</p>
              </div>
            </div>
          </a>
          <a href="#" className="link-dark">
            <div className="bg-light rounded-3 d-flex gap-2 px-3 py-2 mb-3">
              <i className="bi bi-tag-fill text-success" />
              <div>
                <p className="fw-bold mb-0">20% off on kotak Silk Cards</p>
                <p className="small text-muted m-0">20% off up to INR 350</p>
              </div>
            </div>
          </a>
          <a href="#" className="link-dark">
            <div className="bg-light rounded-3 d-flex gap-2 px-3 py-2 mb-3">
              <i className="bi bi-tag-fill text-success" />
              <div>
                <p className="fw-bold mb-0">Mobikwik | ZIP (Pay Later)</p>
                <p className="small text-muted m-0">Get 5% assured cashback</p>
              </div>
            </div>
          </a>
          <div className="cart-box">
            <div className="d-flex align-items-center justify-content-between">
              <h4 className="m-0" />
              <a
                href="checkout.php"
                className="btn btn-primary btn-lg d-flex align-items-center justify-content-between w-100"
              >
                View Cart <span className="fw-bold">$799</span>
              </a>
            </div>
          </div>
        </div> */}
      </div>
      <div className="col-12 border-top pt-4">
      
       <div dangerouslySetInnerHTML={{ __html: CatT.description?.replace(/\$\{location\}/g, capitalizedLocation) }} />

      </div>
    </div>
 

  </div>




</section>

      <div className="bg-white d-none">
        {/* Page Title */}
        {/* <div
          className="py-4 mb-4 mb-lg-0 white"
          style={{ backgroundColor: "whitesmoke" }}
        >
          <div className="container d-lg-flex justify-content-between align-items-center py-2 py-lg-4">
            <div className="pe-lg-4 text-center text-lg-start">
              <h1 className="h3 mb-0">
                {CatT ? <> {CatT.title} </> : <> </>} Category{" "}
              </h1>
            </div>
            <div className="pt-2 pt-lg-0">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb flex-lg-nowrap justify-content-center justify-content-lg-start">
                  <li className="breadcrumb-item">
                    <Link className="text-nowrap" to="/">
                      <i className="ri-store-2-line" /> Home{" "}
                    </Link>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div> */}
        {/* Page Title */}
        {/* Product Category */}
        <div className="container mt-4 pb-4 pb-lg-10">
          <div className="row g-md-4">
         
            {/* Content */}

            <aside className="col-md-12" style={{ flex: 1 }}>
              {CatImage !== undefined && CatImage !== "" ? (
                <>
                  <div
                    className="bg-image p-4 rounded-4"
                    style={{
                      backgroundImage: `url('${CatImage}'`,
                       backgroundBlendMode: "multiply",
                      backgroundColor: "#a0a0a0",
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat"
                    }}
                    
                  >
                    <div className="row align-items-center">
                      <div className="col-md-8">
                      <h1 className="text-white">  {CatT.slide_head?.replace(/\$\{location\}/g, capitalizedLocation)}  </h1>
                      <p className="text-white">{CatT.slide_para?.replace(/\$\{location\}/g, capitalizedLocation)}</p>
                      </div>
                      <div className="col-md-4">
                          
 
              <div className=" bg-light p-4 border-bottom mb-2 border rounded "  >
                <h5
                  className="border-bottom pb-2"
                  style={{ textTransform: "uppercase" }}
                >
               ENQUIRE FOR {CatT ? <> {CatT.title} </> : <> </>} {" "}
                  <i className="ri-chat-3-fill"></i>
                </h5>
                {/* Name input */}
            
            <div className="row">
            <div   className="form-outline mb-4 col-6">
                  <label className="form-label" htmlFor="form5Example1">
                    Full Name <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    id="form5Example1"
                    className="form-control"
                    value={enquireData.fullname}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

                <div   className="form-outline mb-4 col-6 ">
                  <label className="form-label" htmlFor="form5Example2">
                    Email ID <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="email"
                    id="form5Example2"
                    className="form-control"
                    name="email"
                    value={enquireData.email}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

            </div>
          
       

                <div className="mb-4 col-12">
                        <label className="form-label text-dark" htmlFor="name">
                          Phone <span className="text-danger"> ( Required )</span>
                        </label>
                        <div className=" d-flex gap-2  input-sm">
                          <input
                            type="number"
                            id="phone"
                            className={`form-control ${!OTPVerify && 'bg-white' }`}
                            name="phone"
                            value={enquireData.phone}
                            disabled={OTPVerify}
                            onChange={(e) => {
                              if (e.target.value.length <= 10 && !OTPVerify) {
                                // Check input length before updating
                                handleChange(e); // Call handleChange if length is within limit
                              }
                            }}
                            onInput={(e) => {
                              const inputValue = e.target.value;
                              if (inputValue.length <= 10 && !OTPVerify) {
                                setEnquireData({ ...enquireData, phone: inputValue });
                              }
                            }}
                          // onChange={() => {
                          //   handleChange();
                          // }}
                          />
                          {GetOtpRes && OTPVerify && 
                             <button class="btn btn-primary btn-md w-auto rounded-xl" type="button" onClick={ChangePhone}>Edit</button>
                          }
                        {(GetOtpRes && !OTPVerify) ? 
   <button class="btn btn-primary btn-md w-auto rounded-xl" type="button" onClick={()=>{submitOTP(enquireData.phone)}}>Resend OTP</button>
 : !OTPVerify && <button class="btn btn-primary btn-md w-auto rounded-xl" type="button" onClick={()=>{submitOTP(enquireData.phone)}}>Send OTP</button>
  } 
                        </div>
                        {(GetOtpRes && !OTPVerify)  && 
                        <div className="mt-4 d-flex gap-2 col-8 border p-2 rounded w-100 bg-white">

                          <input
                          type="number"
                          id="otp"
                          className="form-control"
                          name="otp"
                          placeholder="Enter OTP"
                          value={enquireData.otp}
                          onChange={(e) => {
                            if (e.target.value.length <= 4) {
                              // Check input length before updating
                              handleChange(e); // Call handleChange if length is within limit
                            }
                          }}
                          onInput={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 4) {
                              setEnquireData({ ...enquireData, otp: inputValue });
                            }
                          }}
                        
                        />
                           <button class="btn btn-primary btn-md w-auto rounded-xl" type="button" onClick={()=>{verifyOTPFinal()}}>Verify</button>

                        </div>
                         }
                      </div>


                

             
                <div data-mdb-input-init="" className="form-outline mb-4 ">
                  <label className="form-label" htmlFor="form5Example2">
                    Requirement{" "}
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <textarea
                     id="requirement"
                    className="form-control"
                    name="requirement"
                    value={enquireData.requirement}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                  <input
                    type="text"
                    id="service"
                    value={enquireData?.service}
                    className="form-control d-none"
                    style={{ boxShadow: "none" }}
                  />
                </div>

                <div
                  className="d-block"
                  style={{ width: "fit-content !important" }}
                >
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handleSendEnquire}
                    disabled={EnquireStatus} // Properly use the `disabled` attribute
                  >
                    Submit
                  </button>
                </div>


              </div>

              <div  
                className={`offcanvas offcanvas-collapse offcanvas-start d-none rounded-3 shadow ${Sidebar && "show"
                  }`}
                id="category-sidebar"
                style={{ maxWidth: "23rem" }}
              >
                <div className="offcanvas-header align-items-center shadow-sm d-none">
                  <h2 className="h5 mb-0">Filters</h2>
                  <button
                    className="btn-close ms-auto"
                    type="button"
                    onClick={Closesidebar}
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  />
                </div>

                {CatT.filter !== 0 && (
                  <div className="offcanvas-body p-lg-8 ">
                    {/* Categories */}
                    <div className="widget widget-categories pb-5 mb-5 ">
                      {/* Price Range Slider */}
                      <div className="widget pb-5 mb-5">
                        <h2>Filtered Products</h2>
                        {/* <ul>
          {filteredProducts.map(product => (
            <li key={product._id}>
              <img src={product.pImage} alt={product.title} />
              <p>{product.title}</p>
              <p>{`Sale Price: $${product.salePrice}`}</p>
            </li>
          ))}
        </ul>
 */}

                        {/* <h3 className="widget-title">Price</h3> */}
                        {filteredPriceRanges &&
                          filteredPriceRanges.length > 0 && <b>Price</b>}
                        <ul className="widget-list pt-1">
                          {filteredPriceRanges.map((range, index) => {
                            const isChecked = selectedRanges.includes(
                              `${range.min}-${range.max}`
                            );
                            return (
                              <li key={index} className="mb-1">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`checkbox-${index}`}
                                    value={`${range.min}-${range.max}`}
                                    onChange={handleCheckpriceboxChange}
                                    checked={isChecked}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`checkbox-${index}`}
                                  >
                                    ₹{range.min} - ₹{range.max}
                                  </label>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      {/* Price Range Slider */}
                      {/* <h3 className="widget-title">Categories</h3> */}

                      {/* Product category */}
{Attr.length} <br/>
{products.length}

{products.map((product) => (
  <div key={product._id}>
    <strong>Product:</strong> {product.slug}
    <ul>
      {product.variations?.map((variation, index) => (
        <li key={index}>{variation.name}</li>
      ))}
    </ul>
  </div>
))}

 

{Attr.map((attr, index) => {
  const hasVariations = products.some(
    (product) =>
      product.variations &&
      product.variations.some((variation) => variation.name === attr.name)
  );

  if (hasVariations) {
    return (
      <div className="accordion-item" key={attr._id}>
        <h2 className="accordion-header" id={`heading${index + 1}`}>
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapse${index + 1}`}
            aria-expanded="true"
            aria-controls={`collapse${index + 1}`}
          >
            {attr.name}
          </button>
        </h2>
        <div
          id={`collapse${index + 1}`}
          className="accordion-collapse collapse show"
          aria-labelledby={`heading${index + 1}`}
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body">
            <ul className="widget-list pt-1">
              {attr.value.map((val, valIndex) => (
                <li className="mb-1" key={`${attr._id}-${valIndex}`}>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={`${attr.name},${val}`}
                      onChange={handleCheckboxChange}
                      id={`checkbox-${valIndex}${attr._id}`}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`checkbox-${valIndex}${attr._id}`}
                    >
                      {val}
                    </label>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }

  return null;
})}


                    </div>
                    {/* Categories */}
                  </div>
                )}
              </div>
       
            {/* Sidebar */}
                      </div>
                    </div>
                 
                  </div>{" "}
                </>
              ) : (
                <div
                  className=" skeleton w-100 h-auto"
                  style={{ aspectRatio: "5/1", objectFit: "cover" }}
                />
              )}

              <div className="row mt-4">
                {isCat
                  ? Array.from({ length: 4 }).map((_, index) => (
                    <div className="col-md-2 col-6">
                      <div
                        className="card-1 skeleton mb-2"
                        style={{ height: 200, borderRadius: 10 }}
                      ></div>
                    </div>
                  ))
                  : Cat.length > 0 &&
                  Cat.map((Cat) => (
                    <>
                      <div className="col-md-2 col-6">
                        <div className="p-0 bg-white rounded">
                          <Link className="col py-2 " to={`/${Cat.slug}`}>
                            <img
                              alt="ICU At Home"
                              width="100%"
                              className="rounded"
                              src={Cat.image}
                              style={{
                                width: "100%",
                                objectFit: "cover",
                                aspectRatio: "1 / 1",
                              }}
                            />
                            <h5 className="text-center text-primary fs-lg px-2 py-2">
                              {" "}
                              {Cat.title}{" "}
                            </h5>
                          </Link>
                        </div>
                      </div>
                    </>
                  ))}
              </div>
              {/* Recommended Products Slider */}
              {/* Toolbar */}
              {CatT.filter !== 0 && (
                <div
                  className="card mt-5 mb-4  "
                  style={{ backgroundColor: "#e2f0f0",width:'max-content',marginLeft:'auto' }}
                >
                  <div className=" px-3   rounded border">
                    <div className="card-body py-2 m " >
                      <div className="d-flex align-items-center justify-content-between">
                        <form className="row row-cols-auto g-4 align-items-center me-3">
                          <div className="col">
                            <div className="row g-2">
                              <label
                                htmlFor="sorting"
                                className="col-auto col-form-label d-sm-block"
                              >
                                No of products
                              </label>
                              <div className="col-auto">
                                <select
                                  className="form-select"
                                  id="sorting"
                                  value={count}
                                  onChange={handlecountChange}
                                >
                                  <option value="50">50</option>
                                  <option value="100">100</option>

                                  <option value="200">200</option>

                                  <option value="500">500</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </form>
                        <ul
                          className="nav nav-pills flex-nowrap"
                          id="pills-tab"
                          role="tablist"
                        >
                          <li
                            className="nav-item d-lg-none"
                            role="presentation"
                          >
                            <button
                              onClick={Opensidebar}
                              className="nav-link active py-2 px-3"
                              id="pills-home-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-home"
                              type="button"
                              role="tab"
                              aria-controls="pills-home"
                              aria-selected="true"
                            >
                              Fillter{" "}
                              <i className="ri-function-line fs-5 ms-2" />
                            </button>
                          </li>

                          {/* <li className="nav-item" role="presentation">
                        <button
                          className="nav-link py-2 px-3"
                          id="pills-profile-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-profile"
                          type="button"
                          role="tab"
                          aria-controls="pills-profile"
                          aria-selected="false"
                        >
                          <i className="ri-list-check fs-5" />
                        </button>
                      </li> */}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}

{Attr.map((attr, index) => {
  const hasVariations = products.some(
    (product) =>
      product.variations &&
      product.variations.some((variation) => variation.name === attr.name)
  );

  // Parse the filters
  let parsedFilters = {};
  try {
    if (Viewfillter) {
      parsedFilters = JSON.parse(Viewfillter);
    }
  } catch (error) {
    console.error("Error parsing Viewfillter:", error);
  }

  // Check if there are any filters applied for this attribute
  const isFiltered = parsedFilters[attr.name];

  if (hasVariations) {
    return (
      <div className="d-block" key={attr._id}>
        <h4 className="m-0">{attr.name}</h4>
        <hr className="w" />
        <div className="d-flex gap-2">
          {attr.value.map((val, valIndex) => {
            // Check if this value is checked in the current filter
            const isChecked = parsedFilters[attr.name]
              ?.split(",")
              .includes(val);

            return (
              <span className={`mb-1 ${isChecked ? 'bg-primary' : 'btn-outline-primary'}`} key={`${attr._id}-${valIndex}`}>
                <div className={`px-3 py-2 rounded ${isChecked ? 'text-white': 'text-dark'}`}>
                  <input
                    className="d-none"
                    type="checkbox"
                    value={`${attr.name},${val}`}
                    onChange={handleCheckboxChange}
                    id={`checkbox-${valIndex}${attr._id}`}
                   />
                  <label
                    className="form-check-label m-0 p-0" type="button"
                    htmlFor={`checkbox-${valIndex}${attr._id}`}
                  >
                    {val}
                  </label>
                </div>
              </span>
            );
          })}
        </div>
      </div>
    );
  }

  return null;
})}


              {/* Toolbar */}

              {/* {Viewfillter && (
                <div className="w-100">
                  {(() => {
                    try {
                      const parsedFilters = JSON.parse(Viewfillter);
                      return Object.entries(parsedFilters).map(
                        ([key, value]) => (
                          <span key={key} className="w-100">
                            {value.split(",").map((val) => (
                              <button
                                onClick={() => removeFilter({ key, val })}
                                className="btn btn-sm btn-secondary py-1 px-2 ms-1 mb-2"
                                key={`${key}-${val}`}
                              >
                                {`${key}: ${val}`} <i class="ri-close-line"></i>
                              </button>
                            ))}
                          </span>
                        )
                      );
                    } catch (error) {
                      console.error("Error parsing Viewfillter:", error);
                      return <div>No filters Found</div>;
                    }
                  })()}
                </div>
              )} */}

              {/* <h2 className="h3 border-bottom pb-4 mb-4">
                Results for   {CatT ? <>  {CatT}  </> : <> loading.. </>}
              </h2> */}

<div className="row">
  
   
 
                <div className="mt-4 col-md-12">

                  {/* Heading */}
   <div
                className={`tab-content ${CatT.filter === 0 && "d-none"}`}
                id="pills-tabContent"
              >
                {/* Product Grid */}
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  {/* Product Cards */}
                  <div className="row pt-2 mx-n2 mb-4 mb-sm-8 bg-light pb-4 border rounded-4">
                    {isCat
                      ? Array.from({ length: 6 }).map((_, index) => (
                        <div
                          key={index}
                          className="col-lg-3 col-md-4 col-sm-6 mt-4"
                        >
                          <div
                            className="card-1 skeleton"
                            style={{ height: 430, borderRadius: 5 }}
                          ></div>
                        </div>
                      ))
                      : Pro.map((product) => {
                        const Images = product.images || [];

                        return (
                          <>
                           <div className="service-item wow fadeInUp col-md-3" data-wow-delay="0.2s">
                            
                                    <div className="service-img">
                                      <Swiper
                                        pagination={true}
                                        navigation={true}
                                        spaceBetween={0}
                                        ref={swiperRefLocal}
                                        autoplay={{
                                          delay: 1500,
                                          pauseOnMouseEnter: true,
                                        }}
                                        loop={true}
                                        modules={[Pagination, Navigation, Autoplay]}
                                        className="img-slider"
                                      >
                                        {Images.map((image, index) => (
                                          <SwiperSlide key={index}>
                                            
                                            <div className="slide-images featured-image">
                                              <Link >
                                                <img
                                                  src={image}
                                                  className="img-fluid w-100"
                                                  alt="img"
                                                />
                                              </Link>
                                            </div>
                                          </SwiperSlide>
                                        ))}
                                      </Swiper>
                                      <div className="trend-icon">
                                        <span className="bg-success">
                                          <i className="feather-trending-up" />
                                        </span>
                                      </div>
                                      {/* <div className="fav-item">
                                        <a href="javascript:void(0);" className="fav-icon">
                                          <i className="ti ti-heart" />
                                        </a>
                                      </div> */}
                                    </div>
                                    <div className="service-content bg-white">
                                      <h6 className="text-truncate mb-1">
                                        <Link to={`/product/${product.slug}`} >
                                        {product.title} 
                                        </Link>
                                      </h6>
                                      <div className="d-flex align-items-center justify-content-between">
                                        {product.salePrice !== 0 || product.regularPrice !== 0 ?
                  <p className="fw-medium fs-14 mb-0">Service starts at @ <b className="text-black"> ₹{product.salePrice} </b></p>
                : 
                <p className="fw-medium fs-14 mb-0 text-danger">Price On Request</p>
                
                                        }
                                        {/* <span className="d-inline-flex align-items-center fs-14">
                                          <i className="ti ti-star-filled text-warning me-1" />
                                          {service.rating}
                                        </span> */}
                                      </div>
                                    </div>
                                  </div>
                          </>
                        );
                      })}

                    {Pro.length === 0 && !isCat && (
                      <div
                        className="container mx-auto my-2 mt-5 py-2 bg-white text-center bg-transparent"
                        style={{
                          height: 193,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <p>No products found for this category.</p>
                      </div>
                    )}

                    <hr className=" d-sm-block" />
                    {/* Pagination */}
                    {/* 
              <div className="d-flex justify-content-between mt-6">
                <ul className="pagination">
                  <li className="page-item">
                    <a className="page-link" href="#">
                      <i className="ri-arrow-left-s-line me-1" />
                      Prev
                    </a>
                  </li>
                </ul>
                <ul className="pagination">
                  <li className="page-item d-sm-none">
                    <span className="page-link page-link-static">1 / 5</span>
                  </li>
                  <li
                    className="page-item active d-none d-sm-block"
                    aria-current="page"
                  >
                    <span className="page-link">
                      1<span className="visually-hidden">(current)</span>
                    </span>
                  </li>
                  <li className="page-item d-none d-sm-block">
                    <a className="page-link" href="#">
                      2
                    </a>
                  </li>
                  <li className="page-item d-none d-sm-block">
                    <a className="page-link" href="#">
                      3
                    </a>
                  </li>
                  <li className="page-item d-none d-sm-block">
                    <a className="page-link" href="#">
                      4
                    </a>
                  </li>
                  <li className="page-item d-none d-sm-block">
                    <a className="page-link" href="#">
                      5
                    </a>
                  </li>
                </ul>
                <ul className="pagination">
                  <li className="page-item">
                    <a className="page-link" href="#" aria-label="Next">
                      Next
                      <i className="ms-1 ri-arrow-right-s-line" />
                    </a>
                  </li>
                </ul>
              </div> */}

                    <div className="d-flex justify-content-between mt-6">
                      <ul className="pagination">
                        <li
                          className={`page-item ${currentPage === 1 ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            type="button"
                            onClick={() => handlePageChange(currentPage - 1)}
                          >
                            <i className="ri-arrow-left-s-line me-1"></i>Prev
                          </button>
                        </li>
                      </ul>
                    
                      <ul className="pagination">
                        <li
                          className={`page-item ${totalPages === 0 ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            type="button"
                            onClick={() => handlePageChange(currentPage + 1)}
                            aria-label="Next"
                          >
                            Next<i className="ms-1 ri-arrow-right-s-line"></i>
                          </button>
                        </li>
                      </ul>
                    </div>

                    {/* Pagination */}
                  </div>
                  {/* Product Cards */}
                </div>
                {/* Product Grid */}
                {/* Product List */}

                {/* Product List */}
              </div>

              
                  <div dangerouslySetInnerHTML={{ __html: CatT.description?.replace(/\$\{location\}/g, capitalizedLocation) }} />
                </div>
     
 
  </div>
 
 
            </aside>
            {/* Content */}
          </div>
         

          {Specifications.length !== 0 &&
            Specifications.map((specification, specIndex) => (
              <>
                <section className="my-4 py-4">
                  <h3 className="text-start mb-3">{specification.heading}</h3>
                  <div className="accordion" id={`accordionID` + specIndex}>
                    {specification.labels.map((label, labelIndex) => (
                      <>
                        <div
                          className="accordion-item mb-2 border rounded overflow-hidden bg-light-theme "
                          key={labelIndex}
                        >
                          <div className="accordion-header bg-transparent">
                            <h4
                              style={{ fontSize: 20, fontWeight: 600 }}
                              className="accordion-button h3 collapsed bg-transparent text-white"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapseOne${labelIndex}`}
                              aria-expanded="false"
                              aria-controls={`#collapseOne${labelIndex}`}
                            >
                              {label.label?.replace(/\$\{location\}/g, capitalizedLocation)}
                            </h4>
                          </div>
                          <div
                            id={`collapseOne${labelIndex}`}
                            className="accordion-collapse collapse"
                            data-bs-parent={`#accordionID${specIndex}`}
                          >
                            <div className="accordion-body text-white">{label.value?.replace(/\$\{location\}/g, capitalizedLocation)}</div>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </section>
              </>
            ))}

 

          {/* Product Cards */}
          <div className="container pb-4 pb-lg-10 d-none">
            {/* Heading */}
            <div className="d-flex flex-wrap justify-content-between align-items-center pt-1 border-bottom pb-4 mb-4">
              <h2 className="h3 mb-0 me-2">Recommended Products</h2>
              <div className="ms-n4">
                {/* <a
                className="btn btn-sm btn-link link-info link-hover-primary d-flex align-items-center bg-btn-new"
                href="#"
              >
                View All
                <i className="ri-arrow-right-line ms-1" />
              </a> */}
              </div>
            </div>
            {/* Heading */}
            {/* Product Cards */}
            <div className="row pt-2 mx-n2 hero-swiper hide-desk-arrow">
              {/* Product Card */}
              <Swiper
                breakpoints={{
                  300: {
                    slidesPerView: 2,
                    spaceBetween: 10, // Set the gap between slides for window width <= 400px
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 20, // Set the gap between slides for window width <= 768px
                  },
                  992: {
                    slidesPerView: 3,
                    spaceBetween: 25, // Set the gap between slides for window width <= 992px
                  },
                  1200: {
                    slidesPerView: 5,
                    spaceBetween: 20, // Set the gap between slides for window width <= 1200px
                  },
                }}
                pagination={true}
                modules={[Pagination, Navigation]}
                className="swiper-wrapper"
              >
                {isProducts
                  ? Array.from({ length: 7 }).map((_, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className="card-1 skeleton"
                        style={{ height: 371, borderRadius: 10 }}
                      ></div>
                    </SwiperSlide>
                  ))
                  : layout.recommended_products && (
                    <>
                      {RProducts.map((product, index) => {
                        const productRatings = ratings.filter(
                          (rating) => rating.productId === product._id
                        );
                        const totalRatings = productRatings.length;
                        const totalRatingValue = productRatings.reduce(
                          (acc, curr) => acc + curr.rating,
                          0
                        );
                        const averageRating =
                          totalRatings > 0
                            ? totalRatingValue / totalRatings
                            : 0;

                        console.log("layout.trending_product.", layout);
                        const myslug = CreateSlug(product.title); // Make sure `data` and `Product` are defined and available in the scope.

                        return (
                          layout.recommended_products.includes(
                            product._id
                          ) && (
                            <>
                              <SwiperSlide key={index}>
                              {/* Product */}
                              <div className="col-sm-6 col-6 col-md-4 px-2 mb-4">
                              <div className="card card-product h-100 bg-light border rounded-4 overflow-hidden bgw-white">
                             
                                {/* Badges */}
                                {/* Buttons */}
                                <div className="product-buttons">
                                  <button
                                    className="btn-product btn-wishlist"
                                    type="button"
                                    data-bs-toggle="button"
                                    title="Add to wishlist"
                                  >
                                    <i className="ri-heart-line" />
                                  </button>
                                  <Link
                                    className="btn-product btn-compare"
                                    href="#"
                                    title="Compare product"
                                  >
                                    <i className="ri-repeat-line" />
                                  </Link>
                                </div>
                                {/* Buttons */}
                                {/* Preview Image */}
                               
                                {/* Preview Image */}
                                <div className="card-body p-2 ">
                                  {/* Product Category */}

                                  {/* <a
                                    className="product-category d-block fs-sm pb-1"
                                    href="#"
                                  >
                                    Smartphones
                                  </a> */}

                                  {/* Product Category */}
                                  {/* Product Title */}
                                  <div className="row justify-content-between w-100 p-0 m-0">
<div className="col">

<h3 className="product-title  mt-2">
                                    <Link to={`/product/${Pro.slug}`}>
                                      {" "}
                                      {Pro.title}{" "}
                                    </Link>
                                  </h3>
</div>
 <div className="col-md-4 text-end">
 <span class="badge btn text-danger bg-white btn-outline-danger">Health</span>

 
 </div>
                                 
                                  </div>

                                  <div className="row justify-content-between w-100 p-0 m-0">
                                    <div className="col">
                                    
                                  
<b className="d-block m-0 p-0">   <i class="ri-microscope-line"></i> {Pro?.features?.length} Parameters  </b> 
<div>Include</div>
                                    </div>

                                    <div className="col text-md-end fs-8">
                                    
                                  
                                    <b className="d-block m-0 p-0">   <i class="ri-calendar-todo-fill"></i>
                                     Report  </b> 
                                    <div>Same Day</div>
                                      </div>

                                  </div>


                                  {/* Star Rating */}
                                  {/* Product Price */}
                                  <div className="row justify-content-between w-100 p-0 m-0">
                                  <div className="product-price col mt-2 ">
                                    {Pro.salePrice === 0 ? (
                                      <span
                                        className="text-danger"
                                        style={{ color: "red" }}
                                      >
                                        Price On request
                                      </span>
                                    ) : (
                                      <span className="text-danger fs-5">
                                        ₹{Pro.salePrice}
                                        <del className="text-body-secondary ms-1">
                                          <small>₹{Pro.regularPrice}</small>
                                        </del>
                                      </span>
                                    )}

                                  
                                  </div>

                                  <Link className="btn btn-sm btn-primary col-md-1 w-auto mt-2 " to={`/product/${Pro.slug}`}>
Book Now
                                  </Link>
                                  </div>
                             
                                  {/* Product Price */}
                                  {/* Product Meta */}

                                  {/* Product Meta */}
                                </div>
                                {/* Product Addon */}

                                {/* Product Addon */}
                              </div>
                            </div>
                            {/* Product */}
                                {/* Product Cards */}
                              </SwiperSlide>
                            </>
                          )
                        );
                      })}
                    </>
                  )}
              </Swiper>
            </div>
            {/* Product Cards */}
          </div>
          {/* Product Cards */}
        </div>

        {/* Product Category */}
      </div>

      <Footer />
    </>
  );
};

export default Category;
